import * as types from '@/org-app/store/modules/epsilonSegments/mutation-types';

const mutations = {
  [types.GET_EPSILON_SEGMENTS](state, segments) {
    state.epsilonSegments = segments;
  },
};

export default mutations;
